
























































import {
  defineComponent,
  reactive,
  Ref,
  ref,
  SetupContext,
} from '@vue/composition-api'

import { IUser, UserRole } from '@/types/user'
import { ISummaries } from '@/types/receipt'

import useVuex from '@/utils/useVuex'
import { navLinks, NavLink } from '@/router/index'

import AppHeader from '@/components/organisms/common/AppHeader.vue'
import { ReceiptState } from '@/types/store'

type Props = {
  title: string
  user: IUser
  isValidationNg: boolean
}

export default defineComponent({
  name: 'Layout',
  components: { AppHeader },
  props: {
    title: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    isValidationNg: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const state = reactive<{
      isSummariesLoading: Ref<boolean>
      summaries: Ref<ISummaries>
    }>({
      isSummariesLoading: useVuex<ReceiptState['isSummariesLoading']>(
        context,
        () => store.getters['receipt/isSummariesLoading'],
      ),
      summaries: useVuex<ReceiptState['summaries']>(
        context,
        () => store.getters['receipt/summaries'],
      ),
    })

    const showDrawer = ref<boolean>(false)
    const hasLogined =
      context.root.$router.currentRoute.path === '/login' ||
      context.root.$router.currentRoute.path === '/input-email' ||
      context.root.$router.currentRoute.path === '/password-setting'

    const isPermitLink = (permission: NavLink['permission']) => {
      if (permission === 'all') {
        return true
      }
      if (permission === 'leader') {
        return (
          props.user.role === UserRole.LEADER ||
          props.user.role === UserRole.ADMIN
        )
      }
      if (permission === 'admin') {
        return props.user.role === UserRole.ADMIN
      }
    }

    const countNow = (link: {
      title: string
      to: string
      summaryKey?: string
      summaryKeyChild?: string
    }): number | undefined => {
      if (link.summaryKey === undefined) {
        return undefined
      }
      if (link.summaryKeyChild === undefined) {
        return (state.summaries as any)[link.summaryKey].now < 0
          ? 0
          : (state.summaries as any)[link.summaryKey].now
      }
      return (state.summaries as any)[link.summaryKey][link.summaryKeyChild]
        .now < 0
        ? 0
        : (state.summaries as any)[link.summaryKey][link.summaryKeyChild].now
    }

    return { state, showDrawer, navLinks, hasLogined, isPermitLink, countNow }
  },
})
